import React from "react";

const UploadIcon = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.875 16.8788C35.9531 16.9013 38.1619 17.0831 39.6019 18.5231C41.25 20.1713 41.25 22.8225 41.25 28.125V30C41.25 35.3044 41.25 37.9556 39.6019 39.6038C37.9556 41.25 35.3025 41.25 30 41.25H15C9.6975 41.25 7.04437 41.25 5.39812 39.6038C3.75 37.9538 3.75 35.3044 3.75 30V28.125C3.75 22.8225 3.75 20.1713 5.39812 18.5231C6.83812 17.0831 9.04688 16.9013 13.125 16.8788"
        stroke="#4F5258"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M22.5 28.125V3.75M22.5 3.75L28.125 10.3125M22.5 3.75L16.875 10.3125"
        stroke="#4F5258"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UploadIcon;
